// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"82cbedc3","1677":"4a50e658","2285":"1f780b23","4154":"4a50e658","7097":"dfd90343","9505":"b07d0802"}[chunkId] + ".chunk.css";
};